module.exports = __webpack_public_path__ + "static/media/avatar7.85cc1c96.png";